import { render, staticRenderFns } from "./bloc-culture.vue?vue&type=template&id=b98e8838"
import script from "./bloc-culture.vue?vue&type=script&lang=js"
export * from "./bloc-culture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports